import SocialConnectConnectorAbstract from './abstract.mjs';

/**
 * @class
 * @extends SocialConnectConnectorAbstract
 */
var SocialConnectConnectorGoogle = function() {

    let _this = this;

    $j.extend(this, new SocialConnectConnectorAbstract(this));

    this._clientInitialized = false;
    this._clientGapiAuth = null;

    this.getType = function() {
        return 'google';
    };

    this._clientInit = function() {
        this._clientInitialized = true;

        gapi.load('auth2', function() {
            _this._clientGapiAuth = gapi.auth2.init({
                client_id: _this.getSettings()['clientId'],
                scope: _this.getSettings()['scope'].join(' '),
            });

            DeferredEvents.trigger(SocialConnectConnectorAbstract.EVENT_INIT_AFTER + '_' + _this.getType());
        });
    };

    /**
     * @returns {JQueryDeferred}
     */
    this._clientConnect = function() {
        return $j.Deferred(function() {
            let deferred = this;

            _this._clientGapiAuth.signIn().then(function(googleUser) {
                let authResponse = googleUser.getAuthResponse();
                _this._clientConnectSuccessCallback({
                    'token': {
                        'access_token': authResponse['access_token'],
                        'token_type': authResponse['token_type'],
                        'created': Math.round(authResponse['first_issued_at'] / 1000),
                        'expires_in': authResponse['expires_in'],
                    },
                }).done(function(data) {
                    deferred.resolve(data);
                });
            }, function(error) {
                _this._clientConnectFailCallback(error);
                deferred.reject(error);
            });
        });
    };

    window.gapiAsyncInit = function() {
        if (!_this._clientInitialized) {
            _this._clientInit();
        }
    };

    this.onInitSettingsAfter(function() {
        if (typeof gapi !== 'undefined' && !_this._clientInitialized) {
            _this._clientInit();
        }
    });

    this.onInitAfter(function() {
        _this._initialized = true;

        if (AitiCore.getCookies().get('G_ENABLED_IDPS') != null) {
            AitiCore.getCookies().set('G_ENABLED_IDPS', AitiCore.getCookies().get('G_ENABLED_IDPS'), {
                expires: 365 * 86400, // 365 days because of UOOU
            });
        }
    });
};

export default SocialConnectConnectorGoogle;
